import jwt_decode from 'jwt-decode'; 
export function permissions() {
    let token = localStorage.getItem('token');
    if (token) {
        return jwt_decode(token).role;
    } else {
        return {};
    }
}